import { EFilesActionTypes } from '../../actions/files';
import { TAppState } from '../../types/appState';
import { EUploadFilesStatus } from '../../types/file';
import { TReduxActions } from '../../types/redux/actions';

export function uploadFilesReducer(state: TAppState, action: TReduxActions): TAppState {
  // @ts-expect-error TODO: переписать, чтобы не отключать линтер
  const openedChat = action?.payload?.chatId && state.openedChats[action.payload.chatId];

  if (!openedChat) {
    return {
      ...state,
    };
  }

  switch (action.type) {
    case EFilesActionTypes.UploadPending:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            pendingFiles: {
              ...openedChat.pendingFiles,
              [action.payload.uid]: {
                blobFiles: action.payload.blobFiles,
                status: EUploadFilesStatus.Pending,
              },
            },
          },
        },
      };

    case EFilesActionTypes.UploadSucceed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            pendingFiles: {
              ...openedChat.pendingFiles,
              [action.payload.uid]: {
                ...openedChat.pendingFiles[action.payload.uid],
                uploadedFiles: action.payload.uploadedFiles,
                status: EUploadFilesStatus.Succeed,
              },
            },
          },
        },
      };

    case EFilesActionTypes.UploadFailed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            pendingFiles: {
              ...openedChat.pendingFiles,
              [action.payload.uid]: {
                ...openedChat.pendingFiles[action.payload.uid],
                status: EUploadFilesStatus.Failed,
              },
            },
          },
        },
      };

    case EFilesActionTypes.WsSendSucceed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            pendingFiles: {
              ...openedChat.pendingFiles,
              [action.payload.uid]: {
                blobFiles: [],
                uploadedFiles: [],
                status: EUploadFilesStatus.WsSucceed,
              },
            },
          },
        },
      };

    default:
      return state;
  }
}
